{
  "nl": {
    "curriculum": {
      "confirmDelete": {
        "confirm": "Ja, verwijderen",
        "text": "Weet je zeker dat je „{filename}“ wilt verwijderen? Het bestand en de doorzoekbare leerplandoelen worden verwijderd.",
        "title": "Leerplan verwijderen?"
      },
      "confirmedUseful": "Leerplan is bevestigd voor de zoekopdracht.",
      "confirmUseful": "Bevestigen voor leerplanzoekopdracht",
      "confirmUsefulFailed": "Leerplan kon niet worden bevestigd.",
      "configure": "Leerplaninstellingen openen",
      "contextPanel": {
        "loadFailed": "De leerplannen konden niet worden geladen. Probeer het later opnieuw.",
        "manage": "Eigen leerplannen beheren",
        "matching": "Deze leerplannen passen bij de bovenstaande schoolgegevens.",
        "noSubject": "Kies hierboven een vak, dan tonen we je passende leerplannen.",
        "noSubjectMatch": "Voor het gekozen vak hebben we geen leerplannen. Upload je eigen leerplan, dan gebruikt de AI het.",
        "none": "Voor deze gegevens hebben we nog geen leerplan. Upload je eigen leerplan, dan gebruikt de AI het.",
        "notFound": "Voor de bovenstaande gegevens hebben we in {place} geen passend leerplan gevonden. Upload je eigen leerplan, dan gebruikt de AI het.",
        "ownDocument": "eigen document",
        "title": "Leerplannen",
        "unknownRegion": "We kennen je deelstaat niet. Om te voorkomen dat de AI een verkeerd leerplan gebruikt, gebruikt deze er dan geen. Stel je deelstaat in in je profiel.",
        "used": "Op deze leerplannen is dit materiaal gebaseerd.",
        "usedIn": "Op deze leerplannen voor {place} is dit materiaal gebaseerd."
      },
      "coverage": {
        "covered": "gedekt",
        "grades": "Klas {range}",
        "heading": "Jouw vakken in {place}",
        "headingWithoutPlace": "Jouw vakken",
        "notCovered": "niet gedekt",
        "openProfile": "Profiel openen",
        "profileIncomplete": "Leg je vakken, schooltype en leerjaren vast in je profiel, dan tonen we je hier de passende leerplannen.",
        "tooltip": {
          "covered": "Bijvoorbeeld {example}",
          "coveredMore": "Bijvoorbeeld {example} en meer",
          "notCovered": "Voor {place} hebben we nog geen officieel leerplan. Upload je eigen leerplan, dan gebruikt de AI het.",
          "otherRegions": "Voor {place} hebben we nog geen officieel leerplan, alleen voor andere deelstaten. Upload je eigen leerplan, dan gebruikt de AI het."
        },
        "unmapped": "Voor {labels} is er geen eigen leerplan. Upload je eigen leerplan, dan gebruikt de AI het."
      },
      "delete": "Leerplan verwijderen",
      "deleted": "Leerplan is verwijderd.",
      "deleteFailed": "Leerplan kon niet worden verwijderd.",
      "empty": "Nog geen eigen leerplandocumenten geüpload.",
      "documentKindDescriptions": {
        "cross_curricular_framework": "Een vakoverstijgend raamplan, bijvoorbeeld voor mediawijsheid of digitale vaardigheden.",
        "curriculum_guidance": "Een handleiding, toelichting of ondersteunend materiaal voor het werken met een leerplan.",
        "general_curriculum_part": "Een algemeen leerplangedeelte zonder specifiek vak, bijvoorbeeld met uitgangspunten of overkoepelende doelen.",
        "non_curriculum": "Dit bestand is niet herkend als een leerplandocument.",
        "presentation_or_training_material": "Presentatie- of nascholingsmateriaal over leerplannen, maar geen eigenlijk leerplan.",
        "subject_curriculum": "Een vakgericht leerplan of vakvereisten voor een concreet schoolvak.",
        "unknown": "Het documenttype kon niet betrouwbaar worden herkend."
      },
      "documentKindLabels": {
        "cross_curricular_framework": "Raamplan",
        "curriculum_guidance": "Handleiding",
        "general_curriculum_part": "Algemeen leerplangedeelte",
        "non_curriculum": "Geen leerplan",
        "presentation_or_training_material": "Presentatie / Nascholing",
        "subject_curriculum": "Vakleerplan",
        "unknown": "Onbekend"
      },
      "fields": {
        "country": "Land",
        "documentKind": "Documenttype",
        "gradeLevel": "Klasniveau",
        "region": "Regio",
        "schoolType": "Schooltype",
        "subject": "Vak",
        "title": "Titel"
      },
      "hints": {
        "customCategoryValue": "Niet gevonden? Voer een eigen waarde in."
      },
      "intro": "We gebruiken de officiële leerplannen uit Duitsland, Oostenrijk en Zwitserland. Daarnaast kun je eigen leerplandocumenten uploaden, bijvoorbeeld een schoolintern curriculum. De AI houdt hier samen met de officiële leerplannen rekening mee.",
      "loading": "Leerplannen worden geladen...",
      "needsReview": "We konden dit document niet eenduidig toewijzen aan een leerplan, vak, klasniveau of schooltype. Het is daarom waarschijnlijk beperkt bruikbaar voor de leerplanzoekopdracht. Vul de gegevens aan of verwijder het bestand.",
      "notSet": "Niet ingesteld",
      "placeholders": {
        "selectOrAddOptions": "Zoeken, selecteren of eigen waarde invoeren"
      },
      "saved": "Leerplanmetadata opgeslagen.",
      "states": {
        "classification_failed": "Automatische herkenning mislukt",
        "classifying": "Leerplan wordt geanalyseerd",
        "file_processing_failed": "Bestand kon niet worden gelezen",
        "import_failed": "Importeren mislukt",
        "indexing": "Wordt overgenomen in de leerplanzoekopdracht",
        "needs_review": "Controle nodig",
        "official": "Officieel leerplan",
        "processing_file": "Bestand wordt verwerkt",
        "searchable": "Doorzoekbaar"
      },
      "statusDescriptions": {
        "classification_failed": "De automatische herkenning kon vak, klasniveau of schooltype niet betrouwbaar bepalen. Je kunt de gegevens handmatig bewerken.",
        "classifying": "De leerplantekst wordt geanalyseerd zodat vak, klasniveau en schooltype kunnen worden voorgesteld.",
        "file_processing_failed": "Het bestand kon niet worden gelezen. Upload een ander PDF-, DOCX- of tekstbestand.",
        "import_failed": "Het leerplan kon niet worden overgenomen in de leerplanzoekopdracht. Controleer de metadata en sla opnieuw op.",
        "indexing": "Het bestand is herkend en wordt voorbereid voor de leerplanzoekopdracht.",
        "needs_review": "Het bestand is technisch verwerkt, maar de leerplanmetadata zijn onduidelijk of onvolledig.",
        "official": "Voor dit gebied zijn officiële leerplangegevens beschikbaar.",
        "processing_file": "Het bestand wordt gelezen en de tekst wordt geëxtraheerd.",
        "searchable": "Het leerplan is geïndexeerd en kan worden gebruikt door de leerplanzoekopdracht."
      },
      "title": "Leerplannen",
      "upload": "Leerplan uploaden",
      "uploaded": "Leerplan is geüpload en wordt verwerkt.",
      "uploadFailed": "Leerplan kon niet worden geüpload."
    }
  }
}
